"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDefaultTextInput = exports.getInputStyles = void 0;
var styled_components_1 = require("styled-components");
var types_1 = require("../utils/types");
var theme_1 = require("../utils/theme");
var common_1 = require("./common");
exports.getInputStyles = function (theme, disabled) {
    var _a;
    var lightActionStyles = disabled ? {} : {
        ':hover:enabled': {
            backgroundColor: theme_1.colors.green50,
            borderColor: theme_1.colors.grey700
        },
        ':focus:enabled': {
            backgroundColor: theme_1.colors.green50,
            borderColor: theme_1.colors.grey700
        },
        ':active:enabled': {
            backgroundColor: theme_1.colors.green50,
            borderColor: theme_1.colors.grey700
        },
    };
    var darkActionStyles = disabled ? {} : {
        ':hover': {
            color: theme_1.colors.white,
            borderColor: theme_1.colors.white,
            backgroundColor: theme_1.colors.transparent,
            '& + svg': {
                fill: theme_1.colors.white
            }
        },
        ':focus': {
            color: theme_1.colors.white,
            borderColor: theme_1.colors.white,
            backgroundColor: theme_1.colors.transparent,
            '& + svg': {
                fill: theme_1.colors.white
            }
        },
        ':active': {
            color: theme_1.colors.white,
            borderColor: theme_1.colors.white,
            backgroundColor: theme_1.colors.grey600,
            '& + svg': {
                fill: theme_1.colors.white
            }
        },
    };
    var inputStyles = (_a = {},
        _a[types_1.LIGHT] = __assign({ '::placeholder': {
                color: theme_1.colors.grey500,
            }, borderColor: theme_1.colors.grey300, caretColor: disabled ? theme_1.colors.grey400 : theme_1.colors.grey700, color: disabled ? theme_1.colors.grey400 : theme_1.colors.grey700, svg: {
                fill: disabled ? theme_1.colors.grey400 : theme_1.colors.grey700,
            } }, lightActionStyles),
        _a[types_1.DARK] = __assign({ '::placeholder': {
                color: theme_1.colors.grey400,
            }, color: disabled ? theme_1.colors.grey500 : theme_1.colors.white, backgroundColor: theme_1.colors.transparent, borderColor: disabled ? theme_1.colors.grey500 : theme_1.colors.grey400, svg: {
                fill: disabled ? theme_1.colors.grey500 : theme_1.colors.grey400,
            } }, darkActionStyles),
        _a);
    return inputStyles[theme];
};
exports.StyledDefaultTextInput = styled_components_1.default.input(__assign(__assign({}, theme_1.font), { '::-ms-clear': {
        display: 'none',
    }, '::-ms-reveal': {
        display: 'none',
    }, WebkitTapHighlightColor: theme_1.colors.transparent, borderRadius: '1px', boxSizing: 'border-box', border: '1px solid', display: 'inline-flex', fontSize: '16px', fontWeight: theme_1.fontWeights.regular, height: '40px', justifyContent: 'center', lineHeight: '20px', outline: 'none', position: 'relative', width: '100%' }), function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return (__assign(__assign(__assign({}, common_1.getCommonDisabled(disabled)), common_1.getCommonFocus(theme)), exports.getInputStyles(theme, disabled)));
}, function (_a) {
    var small = _a.small;
    return small ? {
        height: '32px'
    } : {};
});
//# sourceMappingURL=defaultTextInput.js.map